/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
import { Player } from "../Entities/Player"
import { Shield } from "../Entities/Shields"
import { Bar } from "../Entities/GlobalEntities"
import { GalaxyBar } from "../Entities/GlobalEntities"
import { CircularDoublyLinkedList } from "../cdl";
import { firetail } from "../firetail";
import { FuelBar } from "./../FuelBar";
import { AddImageToScene, createAnimation, MuteBtnCreate, swapMute, destroyOutOfScene, applyMove, applyUnMove, applyShoot, applyShields, applyRepairekits, applySelfDestruction, swapShieldsLeft, swapShieldsRight, swapWeaponsLeft, swapWeaponsRight, consumeFuel } from "./../modules/utiltes"
import { setAmmochosen, currentAmmochosen } from "../modules/storage";
import { SceneGlobales } from "../ScenesHelpers/SceneGlobales";
import { TextManager } from './../ScenesHelpers/TextManager';
import { SoundManager } from '../ScenesHelpers/SoundManager';
import { keyManager } from '../ScenesHelpers/KeyManager';
import { EnemyHandler } from './../ScenesHelpers/EnemyHandler';
import { verifyBeforeUpdateEmail } from "firebase/auth";

/////////////////////////// Global Var ///////////////////////////////////////
///////////////////////////////////////
export class SceneMain extends Phaser.Scene {
    constructor() {
        super({
            key: "SceneMain",
        });
        this.specificammoText = []
        this.shootObar = []
        this.shieldObar = []
        this.repairekitObar = {}
        this.shootchosen = 0;
        this.shieldchosen = 0;
        this.activate = false;
        this.weaponsfinished = 0
        this.mutebtn = null
        this.sceneGlobal = new SceneGlobales()
        this.textManager = new TextManager()
        this.keyManager = new keyManager()
    }

    init(data) {
        // Access the mode parameter passed from Scene 1
        this.mode = data.mode;
        this.playerData = data.player
        this.weaponsData = data.weapons
        this.shieldsData = data.shields
        this.repairekitsData = data.repairekits
        this.enemiesData = data.enemies
        this.enemyshootsData = data.enemyshoots
    }
    create() {
            ///// set assets loaaded on scene/////////////////////
            //////////////////////////////////////////////////////////////
            let scene = this
            this.weaponsfinished = 0
            SceneGlobales.setCapacity(0)
            this.weaponsData.forEach((weaponData) => {
                setAmmochosen(weaponData.ammo, `${weaponData.ammo_key}`);
            });
            this.mute = MuteBtnCreate(this, "assets/img/game/mute.png")
            this.bg = AddImageToScene(this, "deepspace")
            this.stageText = this.textManager.AddTextInScene(this, 320, 16, "First Stage", "24px", "#fff")
            this.SpaceshipText = this.textManager.AddTextInScene(this, 16, 80, `Your Spaceship : ${this.playerData.name}`, "10px", "#fff")
            this.highText = this.textManager.AddTextInScene(this, 16, 60, "", "10px", "#fff")
            this.scoreText = this.textManager.AddTextInScene(this, 16, 16, " ", "24px", "#fff")
            this.fuelText = this.textManager.AddTextInScene(this, 350, 52, " ", "10px", "#fff");
            this.fuelText.setTint(0xff0000);
            this.fuelText.setDepth(5);
            this.ammoText = this.textManager.AddTextInScene(this, 350, 90, " ", "10px", "#fff");
            /// create animation for animated assets
            //////////////////////////////////////////////////////////////
            createAnimation(this, "sprExplosion", 32, 0)
            createAnimation(this, "squrebar", 8, 0)
            createAnimation(this, "squrebar2", 8, 0)
            Player.loadAnime(this, this.playerData.name, 45);
            this.weaponsData.forEach((weaponData) => {
                Bar.loadAnime(this, weaponData.bar_key, 8, true);
            });
            this.shieldsData.forEach((shieldData) => {
                Bar.loadAnime(this, shieldData.bar_key, 8, true);
                Shield.loadAnime(this, shieldData.name, 128, true);
            });
            this.repairekitsData.forEach((repairKitData) => {
                Bar.loadAnime(this, repairKitData.bar_key, 8, true);
                this.repairerand = repairKitData.bar_key;
            });
            this.enemiesData.forEach((enemyData) => {
                enemyData.class.loadAnime(this, enemyData.name, 12);
            });
            //// set all general sounds in game in sfx object
            //////////////////////////////////////////////////////
            SoundManager.createSfx(this)
            this.sfx = SoundManager.getSfx()
                /// play and pause sfx
                ///////////////////////////////////////////////////////////////////////////
            SoundManager.playAll()
            SoundManager.pauseAll()
                ///// creating objects of game entites
                ///////////////////////////////////////////////////////////////////
            this.player = new Player(
                this,
                this.game.config.width * 0.5,
                this.game.config.height * 0.5,
                this.playerData.name,
                "player",
                this.playerData.level,
                this.playerData.speed,
                this.playerData.scaleX,
                this.playerData.scaleY,
                this.playerData.fireCapacity,
                this.playerData.maxFuel,
                this.playerData.resilience
            );
            this.player.setCurrentPlayerScore(0);
            this.player.setPlayerHighScore(0)
            this.shootdl = new CircularDoublyLinkedList();
            this.weaponsData.forEach((weaponData, sb) => {
                this.shootObar[sb] = new Bar(
                    this,
                    60 + sb * 60,
                    640,
                    weaponData.bar_key,
                    "Bar",
                    weaponData.bar_key
                );
                this.shootdl.append(sb);
                this.specificammoText[sb] = this.textManager.AddTextInScene(this, 60 + sb * 60 - 5, 600, " ", "10px", "#fff");
                this.specificammoText[sb].setDepth(5);
            });

            this.shielddl = new CircularDoublyLinkedList();
            this.shieldsData.forEach((shieldData, sib) => {
                this.shieldObar[sib] = new Bar(
                    this,
                    240 + sib * 60,
                    560,
                    shieldData.bar_key,
                    "Bar",
                    shieldData.bar_key
                );
                this.shielddl.append(sib);
            });
            this.repairekitdl = new CircularDoublyLinkedList();
            this.repairekitsData.forEach((repairekitData, rb) => {
                this.repairekitObar[rb] = new Bar(
                    this,
                    60 + rb * 60,
                    560,
                    repairekitData.bar_key,
                    "Bar",
                    repairekitData.bar_key
                );
                this.repairekitdl.append(rb);
            });
            this.squrebar = new Bar(this, 60, 640, "squrebar", "Bar", null);
            this.squrebar2 = new Bar(this, 240, 560, "squrebar2", "Bar", null);
            this.squrebar3 = new Bar(this, 60, 560, "squrebar2", "Bar", null);
            this.firetail = new firetail(this, this.player.x, this.player.y + 10, "fire");
            this.GalaxyBar = new GalaxyBar(this, 250, 600, "Galaxy bar");
            this.FuelBar = new FuelBar(this, 300, 50, this.playerData.maxFuel, this.player);
            this.shootObar[this.shootchosen].alpha = 1;
            this.shieldObar[this.shieldchosen].alpha = 1;
            this.repairekitObar[0].alpha = 1;
            this.firetail.create(this);
            this.firetail.firetailPause();

            ///// assign playable keys
            /////////////////////////////////////////////////////////////
            this.keyManager.AssignGameKeys(this)
                /// use add grop function that create multi restore entites created from entites class and give them game object physics
                ////////////////////////////////////////////////
            this.sceneGlobal.createEntitesGroup(this)
                // check on event happening to apply appropirate action 
                //////////////////////////////////////////////////////////////////////
            this.isMoving = false;
            this.input.keyboard.on("keydown", (event) => {
                applyMove(scene, event, scene.sfx)
                switch (event.keyCode) {
                    case 32:
                        this.shootchosen = applyShoot(this, this.weaponsData, this.player, this.weaponsfinished, this.shootchosen)
                        break;
                    case 17: //ControlLeft
                        [this.repairekitObar, this.shootObar, this.shootchosen, this.weaponsData, this.weaponsfinished] = applyRepairekits(this, this.repairerand, this.repairekitObar, this.shootObar, this.shootchosen, this.weaponsData, this.weaponsfinished, this.specificammoText, this.highText, this.scoreText)
                        break;
                    case 83: //S
                        const currentScore = this.player.getCurrentPlayerScore();
                        this.activate = applySelfDestruction(this, this.activate, this.player, currentScore, this.mode)
                        break;
                    case 16: //ShiftLeft
                        this.shieldchosen = applyShields(this, this.shieldsData, this.player, this.shieldchosen)
                        break;

                    case 90: //Z
                        [this.shieldObar, this.shieldchosen] = swapShieldsLeft(this, this.shieldObar, this.shieldchosen)
                        break;

                    case 88: //X"
                        [this.shieldObar, this.shieldchosen] = swapShieldsRight(this, this.shieldObar, this.shieldchosen)
                        break;

                    case 67: //C
                        [this.shootObar, this.shootchosen] = swapWeaponsLeft(this, this.shootObar, this.shootchosen)
                        break;

                    case 86: //V
                        [this.shootObar, this.shootchosen] = swapWeaponsRight(this, this.shootObar, this.shootchosen)
                        break;

                    default:
                        break;
                }
            });
            this.input.keyboard.on("keyup", (event) => {
                applyUnMove(scene, event, scene.sfx)
                switch (event.keyCode) {
                    case 16:
                        this.player.setData(`${this.shieldsData[this.shieldchosen].name}`, false);
                        break;
                    default:
                        break;
                }
            });
            //// creating enemy from deferent type each 2.5 second and create boss only when score reach 20 
            /////////////////////////////////////////////////////////
            this.time.addEvent({
                delay: 2500,
                callback() { EnemyHandler.createEnemy(this, this.enemiesData, this.enemyshootsData, this.player) },
                callbackScope: this,
                loop: true,
            });
            // apply action on game entites when collisoin happen
            ///////////////////////////////////////////////////////////////////////////////////////////////
            this.physics.add.collider(this.shoots, this.enemies, (shoot, enemy) => {
                scene.sceneGlobal.collisoinShootEnemy(scene, enemy, shoot, scene.sfx, scene.player)
            });
            this.physics.add.collider(this.enemyLasers, this.shields, (enemyLaser, shield) => {
                scene.sceneGlobal.collisoinShieldsEnemyLaser(scene, enemyLaser, shield, scene.sfx)
            });
            this.physics.add.collider(this.enemies, this.shields, (enemy, shield) => {
                scene.sceneGlobal.collisoinShieldsEnemy(scene, enemy, shield, scene.sfx)
            });
            this.physics.add.overlap(this.player, this.enemies, (player, enemy) => {
                scene.sceneGlobal.collisoinPlayerEnemy(scene, enemy, player)
            });
            this.physics.add.overlap(this.player, this.enemyLasers, (player, laser) => {
                scene.sceneGlobal.collisoinPlayerEnemyLasers(scene, player, laser)
            });
            // continue creating scene
            //////////////////////////////////////////////////////////////////////////////////////
            this.textManager.setTextOnScene(this.ammoText, `${this.weaponsData[0].name}: ${currentAmmochosen(this.weaponsData[0].ammo_key)}`)
            this.mute.onclick = () => { swapMute(this, "assets/img/game/muted.png", "assets/img/game/mute.png") }
        }
        ////////////////////////////////////////////////////////////////////////////


    update() {
        this.lasthigh = this.player.getPlayerHighScore();
        this.textManager.setTextOnScene(this.highText, `Highest: ${this.lasthigh}`)
        this.textManager.setTextOnScene(this.scoreText, `Score: ${this.player.getCurrentPlayerScore()}`)
            // check if user is reach to maxCapacity of shoots to cool the weapon and shoot again
            ///////////////////////////////////////////////
        this.sceneGlobal.reloadShoot(this, this.sfx)
        this.sceneGlobal.AvoidOutOfBoundries(this, this.player)
        this.sceneGlobal.checkAmmoColor(this.weaponsData, this.specificammoText, this.ammoText, this.shootchosen)
            ////// check if fuel is empty end the game
            /////////////////////////////////////////////////
        consumeFuel(this.player, this.FuelBar);
        this.textManager.setTextOnScene(this.fuelText, `Fuel Left: ${this.player.getfuel()}`);
        this.firetail.update(this.player.x, this.player.y + 20, this);
        if (this.player.getfuel() <= 0) {
            this.firetail.firetailDestroy();
            this.game.sound.pauseAll();
            this.player.explode(false, this);
            this.scene.start("SceneScores", { mode: this.mode, isDead: false, player: this.player });
        }
        /// make shields trager the player
        ///////////////////////////////////////////////////////////////////////////////////
        ///////////
        if (this.shields.getChildren().length != 0) {
            const shield = this.shields.getChildren()[0];
            shield.x = this.player.x;
            shield.y = this.player.y;
        }

        ////////////////
        /////////// check if weapon is finished clear this weapon from bar and select on the next weapon
        ////////////////////////////////////////////////////////////////////////////////////////
        if (currentAmmochosen(`${this.weaponsData[this.shootchosen].ammo_key}`) <= 0) {
            if (this.weaponsfinished < this.weaponsData.length) {
                this.shootObar[this.shootchosen].visible = false;
                this.shootdeleted = this.shootdl.delete(this.shootchosen);
                if (this.shootdeleted != null) {
                    this.shootchosen = this.shootdeleted.value;
                    this.shootObar[this.shootchosen].alpha = 1;
                    this.squrebar.x = this.shootObar[this.shootchosen].x;
                }
            }
            this.weaponsfinished = this.weaponsfinished + 1

        }
        ////// Destroying all assets that out of the scene arena
        ////////////////////////////////////////////////////////////////////////
        destroyOutOfScene(this, this.enemies)
        destroyOutOfScene(this, this.enemyLasers)
        destroyOutOfScene(this, this.shoots)
    }
}